import React, { createContext, useContext, useEffect, useMemo, useState, useCallback } from "react";
import { api } from "../lib/api";

const SettingsContext = createContext(null);

export const SettingsProvider = ({ children }) => {
    const [settings, setSettings] = useState({
        name: "Reno Point",
        tagline: "Katalog Digital · Scan & Lihat",
        logo_path: null,
        whatsapp_number: "",
        cs_numbers: "",
        marquee_text: "",
    });

    const refresh = useCallback(async () => {
        try {
            const { data } = await api.get("/settings");
            setSettings({
                name: data.name || "Reno Point",
                tagline: data.tagline || "Katalog Digital · Scan & Lihat",
                logo_path: data.logo_path || null,
                whatsapp_number: data.whatsapp_number || "",
                cs_numbers: data.cs_numbers || "",
                marquee_text: data.marquee_text || "",
            });
        } catch (error) {
            console.error("Settings fetch failed:", error);
        }
    }, []);

    useEffect(() => {
        refresh();
    }, [refresh]);

    const value = useMemo(() => ({ settings, refresh }), [settings, refresh]);
    return <SettingsContext.Provider value={value}>{children}</SettingsContext.Provider>;
};

export const useSettings = () => useContext(SettingsContext);
